import { gql } from '@apollo/client';
import { blockFragments } from '../blocks';
import { crewMemberFragments } from '../crew-member';
import { workPackageFragments } from '../work-packages';

export const commodityFragments = {
  milestoneActivityItem: gql`
    fragment MilestoneActivityItem on CommodityMilestoneActivity {
      id
      dateTime
      milestoneName
      activity
      milestoneStatus
      comments
      rejectionReason {
        id
        reason
        comments
      }
      rejectionSubReasons {
        id
        reason
        comments
      }
      crewMember {
        id
        firstName
        lastName
        persona
        discipline
        imageUrl
      }
      blockComments {
        ...BlockCommentItem
      }
      orderBy
      currentItrStatus {
        id
        pipeCleanInspectionBy {
          id
          firstName
          lastName
        }
        pipeCleanInspectionDate
      }
      aiPlanningRequestId
      planningAiComment
    }
    ${blockFragments.blockCommentItem}
  `,
};

export const GET_COMMODITY_DETAIL = gql`
  query commodityDetails($input: CommodityReference!, $paging: PagingInput) {
    commodity(input: $input) {
      materialCommodity {
        id
        type {
          id
          name
        }
        sections {
          title
          fields {
            name
            value
            valueType
          }
        }
        milestonesActivityHistory(paging: $paging) {
          total
          cursor
          items {
            ...MilestoneActivityItem
          }
        }
        isoDocument {
          documentNumber
          url
        }
      }
      weld {
        id
        type {
          id
          name
        }
        hasAssignedForeman
        sections {
          title
          fields {
            name
            value
            valueType
          }
        }
        commodityAssignees {
          assignee {
            id
            firstName
            lastName
            persona
            imageUrl
            badgeNumber
            discipline
            supervisor {
             id
             persona
              supervisor {
               id
               persona
               }
            }
          }
          personaType
        }
        milestonesActivityHistory(paging: $paging) {
          total
          cursor
          items {
           ...MilestoneActivityItem
           attachments {
            id
            url
          }
          }
        }
        isoDocument {
          documentNumber
          url
        }
      }
    }
    ${commodityFragments.milestoneActivityItem}
  }
`;

export const GET_MATERIAL_COMMODITY_DETAIL_SECTIONS = gql`
  query commodityDetails($input: CommodityReference!) {
    commodity(input: $input) {
      materialCommodity {
        id
        type {
          id
          name
        }
        sections {
          title
          fields {
            name
            value
            valueType
          }
        }
      }
    }
  }
`;
export const GET_COMMODITIES = gql`
  query commodities($input: CommodityFilterInput!, $paging: PagingInput) {
    commodities(paging: $paging, input: $input) {
      total
      cursor
      items {
        materialCommodity {
          id
          tag
          startDate
          endDate
          earnedHours
          earnedQuantity
          totalEarnableHours
          totalEarnableQuantity {
            ...Quantity
          }
          material {
            mwrs {
              mwrNumber
              mwrDate
            }
            mrrDate
            mwrNumber
            mrrNumber
            deliveryDate
          }
          type {
            id
            name
          }
          isoDocument {
            documentNumber
            url
          }
          milestones {
            id
            name
            hours
            quantity {
              ...Quantity
            }
            type {
              id
              projectItrConfig {
                id
                itrType
                itrMilestoneAction
              }
            }
            timesRejected
            attachments {
              id
              url
              createdAt
              creator {
                id
                firstName
                lastName
                persona
                imageUrl
              }
            }
            currentStatus {
              id
              codeI18n
              rejectionType {
                id
                reason
              }
              comments
              createdAt
              createdBy {
                id
                firstName
                lastName
                imageUrl
              }
            }
            blocks {
              id
              type {
                id
                title
                description
              }
              comments {
                id
                comment
              }
              currentStatusI18n
              statusHistory {
                id
                codeI18n
                createdAt
              }
            }
            weldStatuses {
              id
              tag
              itrRequired
              status {
                id
                status
                statusAt
                statusBy {
                  id
                  firstName
                  lastName
                  persona
                }
              }
              milestones{
               id
               type{
                id
               }
               currentStatus{
                id
               codeI18n
               }
              }
              currentMilestoneType {
                id
              }

              type {
                id
                name
              }
              commodityAssignees {
                assignee {
                  id
                  firstName
                  lastName
                  persona
                  imageUrl
                  shiftType
                  discipline
                }
                personaType
              }
            }
            plannedEndDate
            plannedStartDate
            weekNumber
          }
        }
        weld {
          id
          tag
          isFitupRequired
          pipeDiameter
          pipeMaterial
          startDate
          endDate
          earnedHours
          totalEarnableHours
          hasAssignedForeman
          currentMilestoneType {
          name
          id
          }
          applicableWeldProcedures {
            id
            procedure
          }
          fitupRequest {
            id
            installationCrewMember {
              ...CrewMember
            }
            isFitupRequired
            isWeldingRequired
          }
          status {
            id
            status
            statusAt
            statusBy {
              id
              firstName
              lastName
              persona
              imageUrl
            }
          }
          commodityAssignees {
            assignee {
              id
              firstName
              lastName
              persona
              imageUrl
            }
            personaType
          }
          type {
            id
            name
          }
          isoDocument {
            documentNumber
            url
          }
          currentMilestoneType {
                id
          }
          milestones {
            id
            name
            hours
            quantity {
              ...Quantity
            }
            type {
              id
              projectItrConfig {
                id
                itrType
                itrMilestoneAction
              }
            }
            timesRejected
            attachments {
              id
              url
              createdAt
              creator {
                id
                firstName
                lastName
                persona
                imageUrl
              }
            }
            currentStatus {
              id
              codeI18n
              activity
              rejectionType {
                id
                reason
              }
              rejectionSubReasonTypes {
                id
                reason
                comments
              }
              comments
              createdAt
              createdBy {
                id
                firstName
                lastName
                persona
              }
            }
            blocks {
              id
              type {
                id
                title
                description
              }
              comments {
                id
                comment
              }
              currentStatusI18n
              statusHistory {
                id
                codeI18n
                createdAt
              }
            }
          }
        }
      }
    }
    ${workPackageFragments.quantity}
    ${crewMemberFragments.crewMember}
  }
`;
export const GET_COMMODITIES_BY_COMMODITY_IDS = gql`
  query commoditiesByIds($ids: [ID!]!, $paging: PagingInput) {
    commoditiesByIds(ids: $ids) {
      materialCommodity {
        id
        sections {
          title
          fields {
            name
            value
            valueType
          }
        }
        earnedHours
        earnedQuantity
        workPackage {
          id
          earnedHours
        }
        milestones {
          id
          name
          timesRejected
          attachments {
            id
            url
            createdAt
            creator {
              id
              firstName
              lastName
              persona
              imageUrl
            }
          }
          currentStatus {
            id
            codeI18n
            rejectionType {
              id
              reason
            }
            comments
            createdAt
            createdBy {
              id
              firstName
              lastName
            }
          }
          blocks {
            id
            type {
              id
              title
              description
            }
            comments {
              id
              comment
            }
            currentStatusI18n
            statusHistory {
              id
              codeI18n
              createdAt
            }
          }
        }
        milestonesActivityHistory(paging: $paging) {
          total
          cursor
          items {
            ...MilestoneActivityItem
          }
        }
      }
      weld {
        id
        sections {
          title
          fields {
            name
            value
            valueType
          }
        }
        earnedHours
        hasAssignedForeman
        isPriority
        locationDescription
        itrRequired
        fitupRequest {
          id
          installationCrewMember {
            id
            imageUrl
            badgeNumber
            discipline
            firstName
            lastName
            persona
          }
          isFitupRequired
          isWeldingRequired
          comments
        }
        currentMilestoneStatus {
          id
        }
        status {
          id
          status
          statusAt
          statusBy {
            id
            firstName
            lastName
            persona
          }
        }
        weldedWithProcedure {
          id
          procedure
        }
        attachments {
          id
          url
          createdAt
          creator {
            id
            firstName
            lastName
            persona
            imageUrl
          }
        }
        commodityAssignees {
          personaType
          assignee {
            id
            firstName
            lastName
            persona
            imageUrl
            badgeNumber
            discipline
            supervisor {
              id
              persona
              supervisor {
                id
                persona
              }
            }
          }
        }
        currentMilestoneType {
          id
          name
        }
        milestones {
          id
          name
          type {
            id
          }
          attachments {
            id
            url
            createdAt
            creator {
              id
              firstName
              lastName
              persona
              imageUrl
            }
          }
          isExpired
          timesRejected
          currentStatus {
            id
            codeI18n
            activity
            rejectionType {
              id
              reason
            }
            rejectionSubReasonTypes {
              id
              reason
              comments
            }
            comments
            createdAt
            createdBy {
              id
              firstName
              lastName
            }
          }
          blocks {
            id
            type {
              id
              title
              description
            }
            comments {
              id
              comment
            }
            currentStatusI18n
            statusHistory {
              id
              codeI18n
              createdAt
            }
          }
        }
        milestonesActivityHistory(paging: $paging) {
          total
          cursor
          items {
            id
            milestoneName
            activity
            milestoneStatus
            dateTime
            crewMember {
              id
              imageUrl
              badgeNumber
              discipline
              firstName
              lastName
              persona
            }
            comments
            rejectionReason {
              id
              reason
              comments
            }
            rejectionSubReasons {
              id
              reason
              comments
            }
            attachments {
              id
              url
              createdAt
              creator {
                id
                firstName
                lastName
                persona
                imageUrl
              }
            }
            blockComments {
              ...BlockCommentItem
            }
            orderBy
          }
        }
      }
    }
    ${blockFragments.blockCommentItem}
    ${commodityFragments.milestoneActivityItem}
  }
`;

export const SUBSCRIPTION_COMMODITIES_UPDATED = gql`
  subscription onCommoditiesUpdated {
    commoditiesUpdated {
      commodityIds
      affectedOwnerIds
      projectId
      weldsCurrentStatus {
        id
        status
      }
    }
  }
`;

export const UPDATE_COMMODITY = gql`
  mutation updateCommodity($input: UpdateCommodityInput!) {
    updateCommodity(input: $input) {
      commodity {
        weld {
          id
          location {
            latitude
            longitude
          }
          locationDescription
          weldedWithProcedure {
            id
          }
          commodityAssignees {
            assignee {
              id
            }
            personaType
          }
        }
      }
      error
    }
  }
`;
